import { defineComponent as _defineComponent } from 'vue'
import { createCommentVNode as _createCommentVNode, createVNode as _createVNode, withModifiers as _withModifiers, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

import router from '@/router'
import AppNavigationItems from './AppNavigationItems.vue'
import ProfileMenu from '../AppLayoutHeader/ProfileMenu.vue'


export default /*#__PURE__*/_defineComponent({
  __name: 'AppLayoutMobileSidebar',
  emits: ['close'],
  setup(__props, { emit }) {



const close = () => {
  emit('close')
}

const navigate = (e: CustomEvent<string>) => {
  const route = e.detail
  if (route) {
    router.push({ path: route })
    window.scrollTo(0, 0)
  }
  close()
}

const onLogoClick = () => {
  router.push({ path: '/' })
  close()
}

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("dsf-navbar", {
    dsf_mobile: "",
    dsf_title: "FOR CARRIERS",
    onNavigate: navigate,
    onClose: close,
    onLogoClick: onLogoClick
  }, [
    _createCommentVNode(" Page navigation items "),
    _createVNode(AppNavigationItems),
    _createCommentVNode(" Profile menu items "),
    _createVNode(ProfileMenu, {
      slot: "footer",
      "mobile-mode": true,
      onClose: _cache[0] || (_cache[0] = _withModifiers(() => {}, ["stop"])),
      onItemClick: close,
      class: "mt-auto"
    })
  ], 32 /* HYDRATE_EVENTS */))
}
}

})